// Mock data for Morrisville Communications LLC
// This mirrors real site content; form submissions are mocked (localStorage) until backend is wired.

export const company = {
  name: "Morrisville Communications",
  legalName: "MORRISVILLE COMMUNICATIONS LLC",
  phone: "+1 919-296-3622",
  phoneTel: "19192963622",
  email: "admin@morrisvillecommunications.com",
  salesEmail: "andy.gawai@morrisvillecommunications.com",
  address: "8045 Arco Corporate Dr, Raleigh, NC 27617, USA",
  linkedin: "https://www.linkedin.com/company/morrisville-communications/",
  tagline: "Collaboration & CX Solutions",
  announcement:
    "Not a Reseller but Your Technology Partner! All Our Services Are at No-Cost to You.",
};

export const images = {
  hero: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzg5NTAwODIwfDA&ixlib=rb-4.1.0&q=85",
  customerService: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxjYWxsJTIwY2VudGVyfGVufDB8fHx8MTc4OTUwMDgyMHww&ixlib=rb-4.1.0&q=85",
  support: "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjYWxsJTIwY2VudGVyfGVufDB8fHx8MTc4OTUwMDgyMHww&ixlib=rb-4.1.0&q=85",
  consulting: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzg5NTAwODIwfDA&ixlib=rb-4.1.0&q=85",
  unified: "https://images.unsplash.com/photo-1588058365815-c96ac30ee30f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxsYXB0b3AlMjBtb2JpbGV8ZW58MHx8fHwxNzg5NTAwODIwfDA&ixlib=rb-4.1.0&q=85",
  whyus: "https://images.unsplash.com/photo-1426024084828-5da21e13f5dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjBtb2JpbGV8ZW58MHx8fHwxNzg5NTAwODIwfDA&ixlib=rb-4.1.0&q=85",
};

export const navLinks = [
  { label: "What We Do?", path: "/" },
  { label: "Why Us?", path: "/why-us" },
  { label: "TEM", path: "/tem" },
  { label: "RingCentral", path: "/providers/ringcentral" },
  { label: "GoTo", path: "/providers/goto" },
  { label: "8x8", path: "/providers/8x8" },
  { label: "Zoom", path: "/providers/zoom" },
  { label: "Dialpad", path: "/providers/dialpad" },
  { label: "Cisco", path: "/providers/cisco" },
  { label: "Vonage", path: "/providers/vonage" },
  { label: "PanTerra", path: "/providers/panterra" },
  { label: "Five9", path: "/providers/five9" },
  { label: "Contact Us!", path: "/contact" },
];

export const partners = [
  "GoTo", "RingCentral", "Dialpad", "8x8", "Panterra Networks", "Microsoft Teams",
  "Webex", "Cisco", "Zoom", "Vonage", "Nextiva", "CallTower",
];

export const benefits = [
  "End-to-End Support (VoIP services) at ZERO cost to you.",
  "Discounted Implementation Cost.",
  "You pay us only if we install/upgrade your VoIP phone system.",
  "End-to-end installation: call queues, IVR & call flow, phone number porting, etc.",
  "Multiple options to choose from - leave the hassle of gathering information to us.",
  "Worked with 240+ businesses in 2023: Hospitals, News Channels, Manufacturing & Government Agencies.",
  "Switch your provider in 4 to 6 weeks - with ZERO downtime.",
  "Complete support for your phone system installation.",
  "We work with your IT Team to arrange demos and pricing from our Partners.",
  "No consulting fees - we connect you to the right VoIP providers.",
  "Multiple partners to choose from. We advise you on benefits & pricing.",
  "Secondary tech support for lifetime without any extra cost.",
  "We suggest; but you make the final decision.",
];

export const features = [
  { title: "AI Virtual Receptionist", icon: "Bot" },
  { title: "International Calling", icon: "Globe" },
  { title: "Mobile App", icon: "Smartphone" },
  { title: "Conference Calling", icon: "Users" },
  { title: "Call Recording", icon: "Mic" },
  { title: "Custom Greetings", icon: "MessageSquare" },
];

export const valueProps = [
  {
    title: "99.999% Uptime Guarantee",
    icon: "ShieldCheck",
    text: "Choose from a wide range of 37 VoIP providers with a financially backed SLA of 99.999% uptime. Get up to 3 free months & a partner discount of 15% to 40% depending on user size.",
  },
  {
    title: "Our Services",
    icon: "Headset",
    text: "End-to-End & hassle-free support to set up your phone system. We will never share your contact information with any partner prior to your verbal/written consent.",
  },
  {
    title: "Our Customer Service",
    icon: "HeartHandshake",
    text: "We pride ourselves on exceptional customer service. Our friendly, knowledgeable staff are always here to help and are committed to your complete satisfaction.",
  },
];

export const serviceCards = [
  {
    title: "Reliable Service",
    icon: "CheckCircle2",
    text: "Complete support for your phone system installation. We work with your IT Team to arrange demos and pricing from our partners - with no consultation charges and no obligations.",
  },
  {
    title: "24/7 Customer Support",
    icon: "Clock",
    text: "Our technical staff does all the groundwork and presents the best communication provider for your needs. We work with just about any technology a small business would encounter.",
  },
  {
    title: "Flexible Plans",
    icon: "SlidersHorizontal",
    text: "Multiple partners on board to get you the best possible deal. We assure about a 32% budget cut on your current bills for VoIP services.",
  },
  {
    title: "Easy Setup",
    icon: "Rocket",
    text: "Setting up our telephone services is easy and straightforward. We provide step-by-step guidance so you can start quickly - no tech expertise required.",
  },
  {
    title: "Advanced Features",
    icon: "Sparkles",
    text: "From call forwarding to voicemail transcription, our advanced features streamline your operations. Customize settings to suit your needs.",
  },
  {
    title: "Best Possible Deal",
    icon: "BadgePercent",
    text: "We help you get your VoIP phone system ready and installed, with pricing and quotes from top VoIP providers for your communication needs.",
  },
];

export const providers = {
  ringcentral: {
    name: "RingCentral",
    badge: "RingCentral Certified Sales Partner",
    color: "#0684BC",
    website: "https://www.ringcentral.com/",
    headline: "RingCentral is a market-leading UC & Contact Centre provider",
    intro:
      "RingCentral's cloud-based platform combines internal and external communications tools such as messaging, video conferencing, telephony and customer engagement in a single integrated system, making processes much more efficient.",
    highlights: [
      { title: "UC Platform (RingEX)", text: "All-in-one message, video and phone across every device with enterprise-grade reliability." },
      { title: "Contact Centre (RingCX)", text: "AI-powered, easy-to-use contact center with omnichannel routing and analytics." },
      { title: "Competitive Matrix", text: "See how RingCentral compares across features, reliability and value for your business." },
    ],
  },
  goto: {
    name: "GoTo",
    badge: "GoTo Solutions Partner",
    color: "#F68D2E",
    website: "https://www.goto.com/",
    headline: "GoTo Connect - simple, secure, all-in-one communications",
    intro:
      "GoTo Connect brings together cloud phone, meetings and messaging in one flexible, easy-to-manage platform - built for teams that need to stay connected anywhere.",
    highlights: [
      { title: "GoTo Connect", text: "Cloud phone system with 100+ features, an intuitive admin portal and simple setup." },
      { title: "Meetings & Webinars", text: "HD video meetings and webinars that keep teams and customers engaged." },
      { title: "Contact Center", text: "Streamline customer conversations across voice, SMS and web chat." },
    ],
  },
  "8x8": {
    name: "8x8",
    badge: "8x8 Partner",
    color: "#F03D3E",
    website: "https://www.8x8.com/",
    headline: "8x8 XCaaS - one platform for UC & Contact Center",
    intro:
      "8x8 unifies contact center, voice, team chat, video meetings and SMS in a single cloud platform with a financially backed 99.999% uptime SLA across the globe.",
    highlights: [
      { title: "Unified Communications", text: "Voice, video, chat and meetings integrated for seamless collaboration." },
      { title: "Contact Center", text: "Omnichannel routing, AI and analytics to elevate customer experience." },
      { title: "Global Reach", text: "Enterprise-grade calling to 40+ countries with reliable quality." },
    ],
  },
  zoom: {
    name: "Zoom",
    badge: "Zoom Channel Partner",
    color: "#2D8CFF",
    website: "https://www.zoom.com/",
    headline: "Zoom - the platform teams already love, now for your phone",
    intro:
      "Zoom Workplace unifies phone, meetings, chat and whiteboard with AI Companion built in - so your team communicates and collaborates without switching apps.",
    highlights: [
      { title: "Zoom Phone", text: "Modern cloud phone system with global coverage and simple management." },
      { title: "Meetings & Chat", text: "Reliable HD video and team chat your employees already know." },
      { title: "AI Companion", text: "Summaries, drafting and smart assistance built into the platform." },
    ],
  },
  dialpad: {
    name: "Dialpad",
    badge: "Dialpad Partner",
    color: "#7C3AED",
    website: "https://www.dialpad.com/",
    headline: "Dialpad - the AI-powered customer communications platform",
    intro:
      "Dialpad brings AI to every conversation with real-time transcription, live coaching and sentiment analysis across business phone, contact center and sales.",
    highlights: [
      { title: "Ai Voice", text: "Business phone with real-time transcription and AI-powered call summaries." },
      { title: "Ai Contact Center", text: "Live agent assist and coaching to improve every customer interaction." },
      { title: "Ai Sales", text: "Boost win rates with real-time recommendations for your sales team." },
    ],
  },
  cisco: {
    name: "Cisco",
    badge: "Cisco Webex Partner",
    color: "#1BA0D7",
    website: "https://www.webex.com/",
    headline: "Cisco Webex - secure, enterprise-grade collaboration",
    intro:
      "Webex by Cisco delivers calling, meetings, messaging and contact center with enterprise-grade security and reliability trusted by organizations worldwide.",
    highlights: [
      { title: "Webex Calling", text: "Cloud calling with enterprise security and global PSTN options." },
      { title: "Meetings", text: "Immersive, AI-enhanced video meetings and webinars." },
      { title: "Contact Center", text: "Cloud contact center with intelligent routing and analytics." },
    ],
  },
  vonage: {
    name: "Vonage",
    badge: "Vonage Partner",
    color: "#8000FF",
    website: "https://www.vonage.com/",
    headline: "Vonage - flexible cloud communications for every business",
    intro:
      "Vonage Business Communications combines phone, messaging and video with a rich API platform, so you can connect with customers on the channels they prefer.",
    highlights: [
      { title: "Business Communications", text: "Unified phone, messaging and video with 40+ business features." },
      { title: "Contact Center", text: "Intelligent routing and CRM integrations for better CX." },
      { title: "Communications APIs", text: "Embed voice, SMS and verification directly into your apps." },
    ],
  },
  panterra: {
    name: "PanTerra",
    badge: "PanTerra Streams AI Partner",
    color: "#0EA5A4",
    website: "https://www.panterranetworks.com/",
    headline: "PanTerra Streams AI - all-in-one, AI-powered cloud communications",
    intro:
      "PanTerra Networks unifies calling, SMS, fax, video, team messaging, and a contact center in one AI-powered UCaaS platform called Streams AI - backed by a 99.999% uptime SLA, 30-second US-based live support, and deployment in as little as one business day.",
    highlights: [
      { title: "Streams AI Platform", text: "UCaaS + CCaaS in one - calling, messaging, video, fax, and file sharing with AI built in." },
      { title: "Luna AI Receptionist", text: "A 24/7 AI receptionist that answers and routes every call so you never miss a lead." },
      { title: "In-House US Support", text: "30-second live response from stateside engineers who build and own the platform." },
    ],
  },
  five9: {
    name: "Five9",
    badge: "Five9 CCaaS Partner",
    color: "#1E9BD7",
    website: "https://www.five9.com/",
    headline: "Five9 - the AI-powered cloud contact center for extraordinary CX",
    intro:
      "Five9 is a leading cloud contact center (CCaaS) provider that helps organizations deliver exceptional customer experiences. Its AI-driven platform blends intelligent automation with human agents across voice and digital channels, backed by 99.999% uptime and trusted by 3,000+ businesses worldwide.",
    highlights: [
      { title: "Genius AI", text: "Conversational and generative AI that anticipates customer needs and assists agents in real time." },
      { title: "Omnichannel Journeys", text: "Orchestrate voice, chat, email, SMS, and social in one seamless customer journey." },
      { title: "Intelligent CX Platform", text: "A scalable, secure platform with open APIs, easy integration, and 99.999% uptime." },
    ],
  },
};

// Enriched, originally-written product overviews (paraphrased from public info)
export const providerDetails = {
  ringcentral: {
    longIntro:
      "RingCentral is a global leader in cloud communications, trusted by more than 600,000 businesses across 100+ countries and backed by 99.999% availability. Its AI-first platform unites business phone, messaging, video, and customer engagement so teams and customers stay connected from anywhere - and it has been named a Gartner Magic Quadrant Leader for UCaaS for 12 consecutive years.",
    stats: [
      { value: "600k+", label: "Businesses worldwide" },
      { value: "100+", label: "Countries supported" },
      { value: "99.999%", label: "Availability" },
      { value: "12 yrs", label: "Gartner MQ Leader" },
    ],
    products: [
      { name: "RingEX", text: "AI-powered business phone, team messaging, SMS, and video in one app across every device." },
      { name: "RingCX", text: "AI-native contact center with omnichannel routing, outbound dialing, and workforce engagement." },
      { name: "AI Receptionist (AIR)", text: "Answers calls 24/7, routes callers accurately, captures leads, and books appointments automatically." },
      { name: "AI Virtual Assistant (AVA)", text: "Real-time notes, summaries, instant translations, and workflow automation on every conversation." },
      { name: "Meetings & Events", text: "HD video meetings, webinars, town halls, and rooms for teams and large audiences." },
      { name: "Open Platform", text: "500+ pre-built integrations plus open APIs, including Microsoft Teams and Salesforce." },
    ],
  },
  goto: {
    longIntro:
      "GoTo Connect is an all-in-one, AI-powered cloud communications platform built for small, mid-sized, and multi-location businesses. It combines a powerful cloud phone system with meetings, messaging, and a modern contact center - remarkably simple to set up and easy to manage, often live in as little as a day.",
    stats: [
      { value: "~1 day", label: "Typical go-live" },
      { value: "SMB", label: "Enterprise tech, SMB pricing" },
      { value: "24/7", label: "Award-winning support" },
      { value: "100s", label: "Phone features" },
    ],
    products: [
      { name: "Cloud Phone System", text: "Hundreds of features with softphone and SMS - great for the office, home, or on the go." },
      { name: "Meetings & Messaging", text: "HD video meetings and team messaging built into the same easy platform." },
      { name: "Contact Center", text: "Enterprise-grade, AI-powered omnichannel support across phone, email, chat, and WhatsApp." },
      { name: "AI Receptionist", text: "Automates tasks across voice and digital channels so you never miss a call." },
      { name: "AI Insights", text: "Call summaries, sentiment analysis, and topic monitoring across calls, texts, and social." },
      { name: "Easy Integrations", text: "Works with ServiceNow, Zendesk, Microsoft Teams, and the tools you already use." },
    ],
  },
  "8x8": {
    longIntro:
      "8x8 unifies contact center, unified communications, and communication APIs (CPaaS) on one intelligent, globally reliable platform. Trusted by more than 3 million business users and backed by a financially guaranteed 99.999% uptime SLA, 8x8 removes silos so every customer conversation continues seamlessly across channels.",
    stats: [
      { value: "3M+", label: "Business users" },
      { value: "99.999%", label: "Uptime SLA" },
      { value: "Top", label: "Metrigy MetriStar CPaaS" },
      { value: "Global", label: "Worldwide reach" },
    ],
    products: [
      { name: "Unified Communications", text: "Voice, team chat, video meetings, and SMS in a single cloud app." },
      { name: "Contact Center", text: "AI-powered omnichannel routing, analytics, and quality management." },
      { name: "8x8 Converse", text: "WhatsApp, messaging, voice, video, and email unified in one AI workspace." },
      { name: "Communication APIs (CPaaS)", text: "Embed SMS, WhatsApp, Viber, voice, and video directly into your apps." },
      { name: "Authentication & Security", text: "OTP and 2FA to protect users and prevent fraud at scale." },
      { name: "Global Reach", text: "Enterprise calling and messaging worldwide with dependable local expertise." },
    ],
  },
  zoom: {
    longIntro:
      "Zoom Workplace is an AI-first, open collaboration platform that brings phone, meetings, team chat, whiteboard, and more together - with AI Companion built in. Your team gets a modern, reliable phone system on the video tools they already know and love, without switching between apps.",
    stats: [
      { value: "AI", label: "Companion included" },
      { value: "Global", label: "Phone coverage" },
      { value: "1 app", label: "Phone, meetings & chat" },
      { value: "Open", label: "Extensible platform" },
    ],
    products: [
      { name: "Zoom Phone", text: "Modern cloud phone system with global coverage, SMS, and simple central management." },
      { name: "Meetings", text: "Reliable HD video meetings with AI Companion summaries and recordings." },
      { name: "Team Chat", text: "Messaging, channels, and file sharing to keep work moving between meetings." },
      { name: "Contact Center", text: "Omnichannel customer experience with AI-powered routing and virtual agents." },
      { name: "AI Companion", text: "Meeting summaries, chat drafting, and smart assistance included at no extra cost." },
      { name: "Whiteboard & Workspaces", text: "Collaborate visually and reserve desks and rooms for hybrid teams." },
    ],
  },
  dialpad: {
    longIntro:
      "Dialpad is an AI-native customer communications platform that unites human and AI agents. It brings real-time transcription, live coaching, and automation to business phone, contact center, and sales - all with enterprise-grade security, including HIPAA compliance and SOC 2 certification.",
    stats: [
      { value: "AI-native", label: "Built-in on every call" },
      { value: "HIPAA", label: "Compliant" },
      { value: "SOC 2", label: "Certified" },
      { value: "Real-time", label: "Transcription & coaching" },
    ],
    products: [
      { name: "Ai Voice", text: "All-in-one business phone, messaging, and video with AI notes and insights." },
      { name: "Ai Contact Center", text: "Real-time agent assist, live coaching, and sentiment analysis for customer service." },
      { name: "Ai Sales", text: "Real-time recommendations and call coaching to help reps close more deals." },
      { name: "Ai Agents", text: "Always-on AI agents that resolve requests autonomously across voice and digital channels." },
      { name: "Real-time Transcription", text: "Accurate live transcripts and automatic call summaries on every conversation." },
      { name: "Integrations", text: "Connects with Salesforce, Zendesk, Microsoft Teams, Google Workspace, and more." },
    ],
  },
  cisco: {
    longIntro:
      "Webex by Cisco is a secure, enterprise-grade suite for calling, meetings, messaging, and contact center. Trusted by organizations worldwide and backed by Cisco's security and reliability, Webex brings AI-enhanced collaboration to distributed teams and hybrid workplaces.",
    stats: [
      { value: "Enterprise", label: "Grade security" },
      { value: "Global", label: "PSTN coverage" },
      { value: "AI", label: "Assistant built in" },
      { value: "Hybrid", label: "Devices & rooms" },
    ],
    products: [
      { name: "Webex Calling", text: "Cloud calling with enterprise security and global PSTN options." },
      { name: "Meetings & Webinars", text: "Immersive, AI-enhanced video meetings, webinars, and events." },
      { name: "Contact Center", text: "Cloud contact center with intelligent routing and rich analytics." },
      { name: "Team Messaging", text: "Spaces, file sharing, and collaboration that keep teams aligned." },
      { name: "AI Assistant", text: "Real-time summaries, transcription, and translations across meetings." },
      { name: "Devices & Rooms", text: "Certified headsets and desk and room systems for hybrid work." },
    ],
  },
  vonage: {
    longIntro:
      "Vonage delivers flexible cloud communications for businesses of every size - combining a full unified communications suite with a powerful communications API platform. Reach customers on any channel, automate interactions with AI, and embed voice, video, and messaging directly into your own applications.",
    stats: [
      { value: "40+", label: "Business features" },
      { value: "APIs", label: "Voice, video & SMS" },
      { value: "Global", label: "Reach" },
      { value: "AI", label: "Self-service & routing" },
    ],
    products: [
      { name: "Business Communications", text: "Unified phone, messaging, and video with 40+ business-ready features." },
      { name: "Contact Center", text: "Intelligent routing, CRM integrations, and analytics for better CX." },
      { name: "Communications APIs", text: "Embed voice, video, SMS, verification, and WhatsApp into your apps." },
      { name: "Global Voice & Messaging", text: "Connect with customers worldwide on the channels they prefer." },
      { name: "AI & Self-Service", text: "Virtual assistants and conversational AI to automate interactions." },
      { name: "Integrations", text: "Works with Salesforce, Microsoft Teams, and popular CRMs." },
    ],
  },
  panterra: {
    longIntro:
      "Founded in 2001 and headquartered in San Jose, CA, PanTerra Networks is a UCaaS and CCaaS provider that has served businesses from 5 to 5,000+ employees for over two decades. Its Streams AI platform unifies voice, video, messaging, fax, file sharing, and an AI contact center in one place - built and supported entirely in-house, with HIPAA compliance, SOC 2 Type II data centers, and a financially backed 99.999% uptime SLA.",
    stats: [
      { value: "99.999%", label: "Uptime SLA" },
      { value: "~1 day", label: "Typical go-live" },
      { value: "30 sec", label: "US support response" },
      { value: "20+ yrs", label: "In business since 2001" },
    ],
    products: [
      { name: "Luna AI Receptionist", text: "A 24/7 AI receptionist with smart call routing so no call ever goes unanswered." },
      { name: "Cloud PBX & Mobile Voice", text: "Enterprise-grade calling anywhere your teams work, on desktop or mobile." },
      { name: "Contact Center AI", text: "Predictive routing, omnichannel engagement, virtual agents, and real-time insights." },
      { name: "Team Messaging & File Sharing", text: "Built-in, fully synced collaboration across devices and locations." },
      { name: "Video Conferencing AI", text: "Real-time captions, transcriptions, and automatic meeting insights." },
      { name: "Microsoft Teams Integration", text: "Calling, SMS, and fax inside Teams - with continuity even if Teams goes down." },
    ],
  },
  five9: {
    longIntro:
      "Five9 is a pioneer of cloud contact center software and a repeat Gartner Magic Quadrant CCaaS Leader (named a Leader for the 8th time in 2025). Its Intelligent CX Platform unites AI Agents, Agent Assist, omnichannel routing, workforce engagement, and analytics - helping 3,000+ organizations worldwide automate routine interactions, empower live agents, and turn every conversation into a loyalty-building moment, all backed by a 99.999% uptime commitment.",
    stats: [
      { value: "99.999%", label: "Uptime" },
      { value: "3,000+", label: "Global customers" },
      { value: "8x", label: "Gartner MQ Leader" },
      { value: "AI", label: "Genius AI built in" },
    ],
    products: [
      { name: "AI Agents", text: "Autonomous, intent-matching AI that resolves routine inquiries across voice and digital channels." },
      { name: "Agent Assist", text: "Real-time transcription, guidance, and next-best-action to support your live agents." },
      { name: "Omnichannel Routing", text: "Intelligent routing across voice, email, chat, SMS, and social channels." },
      { name: "Workforce Engagement (WEM)", text: "Forecasting, scheduling, quality management, and performance tools for agents." },
      { name: "Genius AI Studio", text: "Conversational and generative AI to design and automate personalized customer journeys." },
      { name: "Analytics & Reporting", text: "Real-time dashboards and insights to measure, benchmark, and improve CX." },
    ],
  },
};

export const providerOrder = [
  "ringcentral", "goto", "8x8", "zoom", "dialpad", "cisco", "vonage", "panterra", "five9",
];

// Telecom Expense Management (TEM) - Home page section content (original copy)
export const tem = {
  eyebrow: "Telecom Expense Management (TEM)",
  title: "Take control of your VoIP & telecom spend",
  intro:
    "Beyond setting up your VoIP phone system, we help you manage what it costs. Our Telecom Expense Management service audits your invoices, right-sizes your plans and licenses, and keeps your business phone spend lean - so you never pay for lines, seats, or features you don't use.",
  benefits: [
    "Uncover an average 32% reduction on current VoIP & telecom bills.",
    "Reclaim unused DID numbers, licenses, and zombie user seats.",
    "One clear view of every carrier, VoIP provider, and monthly charge.",
  ],
  features: [
    {
      icon: "ReceiptText",
      title: "Invoice Audit & Recovery",
      text: "We review your current VoIP and carrier invoices line by line to catch billing errors, double charges, and services you no longer use - then recover the savings.",
    },
    {
      icon: "SlidersHorizontal",
      title: "License & Seat Optimization",
      text: "Right-size user licenses, call paths, and add-ons across RingCentral, GoTo, 8x8, Zoom, Dialpad and more - so you only pay for what your team actually needs.",
    },
    {
      icon: "LayoutDashboard",
      title: "Single Pane of Glass",
      text: "See every provider, phone number, and recurring charge in one inventory - making it simple to track spend across locations and departments.",
    },
    {
      icon: "FileSignature",
      title: "Contract & Renewal Management",
      text: "We track contract end dates and renewal windows, then negotiate with partners on your behalf so you never auto-renew into an overpriced plan.",
    },
    {
      icon: "PhoneForwarded",
      title: "Number & Porting Oversight",
      text: "Full visibility of DID inventory and porting status during a provider switch - with zero downtime and no orphaned numbers left billing you.",
    },
    {
      icon: "TrendingDown",
      title: "Ongoing Cost Governance",
      text: "Continuous monitoring of usage and spend, with alerts on overages and monthly optimization recommendations for your VoIP phone system.",
    },
  ],
};

// Deeper TEM page content
export const temPage = {
  heroTitle: "Telecom Expense Management for Business VoIP",
  heroSubtitle:
    "Audit, optimize, and continuously govern your VoIP phone system and telecom spend - so every dollar works as hard as your business does.",
  whatIs: {
    title: "What is Telecom Expense Management?",
    body:
      "Telecom Expense Management (TEM) is the discipline of gaining full visibility and control over everything your organization spends on communications - VoIP phone systems, mobile, internet, SIP trunks, and carrier services. As businesses adopt hosted VoIP and add users across locations, invoices grow complex and overspend creeps in: forgotten lines, unused licenses, mismatched plans, and billing errors. Our TEM service brings all of it into one inventory, audits every charge, and keeps your VoIP spend optimized month after month.",
  },
  whyMatters: [
    { icon: "Search", title: "Hidden overspend adds up", text: "A meaningful share of telecom invoices contain errors or charges for unused services. On a growing VoIP estate, that quietly compounds every month." },
    { icon: "Boxes", title: "VoIP sprawl is hard to track", text: "Multiple providers, DID ranges, seats, and add-ons across sites make it tough to know what you actually use - and what you're paying for." },
    { icon: "ShieldCheck", title: "No cost, no obligation", text: "We only recommend changes that save you money. There are no consulting fees - we're paid by our VoIP partners, not by you." },
  ],
  process: [
    { step: "01", title: "Discovery & Inventory", text: "We map every phone number, user seat, license, and recurring charge across all your VoIP providers and carriers into a single source of truth." },
    { step: "02", title: "Invoice Audit", text: "Line-by-line review of current invoices to surface billing errors, duplicate charges, and services no longer in use." },
    { step: "03", title: "Optimization Plan", text: "We right-size plans and licenses and model the best-fit VoIP provider mix, with a clear ROI/TCO comparison." },
    { step: "04", title: "Negotiation & Implementation", text: "We negotiate partner pricing on your behalf and coordinate porting, provisioning, and cutover with zero downtime." },
    { step: "05", title: "Ongoing Governance", text: "Continuous monitoring of usage and spend, renewal tracking, and monthly recommendations to keep costs optimized." },
  ],
  faqs: [
    { q: "Does TEM only apply to VoIP phone systems?", a: "TEM covers your full communications estate - hosted VoIP, mobile, internet, SIP trunks, and carrier services - but for most clients the biggest, fastest savings come from optimizing their business VoIP phone system." },
    { q: "How much can we typically save?", a: "Most businesses see meaningful reductions on their monthly VoIP and telecom bills - commonly in the 15% to 40% range depending on team size and how their current plans are structured. We'll quantify your specific opportunity in a free bill review." },
    { q: "Will switching providers cause downtime?", a: "No. We manage number porting and cutover carefully so your business phones keep working throughout the transition, with zero downtime." },
    { q: "What does TEM cost us?", a: "Nothing. We don't charge consulting fees. We're compensated by our VoIP partners when you choose to move forward, so our guidance stays no-cost and no-obligation." },
  ],
};

// Representative TEM results (illustrative examples, not specific client names)
export const caseStudies = {
  disclaimer:
    "Figures below are representative examples based on typical engagements and are shown for illustration only.",
  items: [
    { sector: "Regional Healthcare Group", users: "240 users", savingsPct: "34%", annual: "$61,000", note: "Consolidated 3 carriers and removed 40+ unused seats." },
    { sector: "County Government Agency", users: "180 users", savingsPct: "29%", annual: "$44,000", note: "Renegotiated the contract before the auto-renewal window." },
    { sector: "Multi-site Manufacturer", users: "320 users", savingsPct: "31%", annual: "$58,000", note: "Right-sized licenses across 6 locations." },
    { sector: "Local News Network", users: "90 users", savingsPct: "27%", annual: "$21,000", note: "Recovered billing errors and dormant DID numbers." },
  ],
};

